const formatAddress = (
  city?: string | null,
  zip?: string | null,
  country?: string | null
) => {
  const parts = [city, zip, country].filter((part): part is string =>
    Boolean(part?.trim())
  );

  return parts.length > 0 ? parts.join(', ') : '—';
};

export { formatAddress };
